import { render, staticRenderFns } from "./BaseIconClickable.vue?vue&type=template&id=76d87c42&"
import script from "./BaseIconClickable.vue?vue&type=script&lang=js&"
export * from "./BaseIconClickable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports